import { render, staticRenderFns } from "./Dog-Criador.vue?vue&type=template&id=70ca571e&scoped=true&"
import script from "./Dog-Criador.vue?vue&type=script&lang=js&"
export * from "./Dog-Criador.vue?vue&type=script&lang=js&"
import style0 from "./Dog-Criador.vue?vue&type=style&index=0&id=70ca571e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca571e",
  null
  
)

export default component.exports